<template>
  <div class="row">
    <input-text class="col-2" label="Nº etapa" disabled v-model="etapaNumero" />
    <input-text
      class="col-10 col-md-4"
      @blur="salvarEtapa"
      label="Titulo da etapa"
      v-model="form.etapa.tituloDaEtapa"
      ref="tituloEtapa"
      required
    />
    <input-select
      class="col-12 col-md-3"
      @input="salvarEtapa"
      :disabled="!controlesLiberados"
      :has-error-custom="erroEtapa"
      :options="mesesDepesas"
      v-model="form.etapa.mesInicialRealizado"
      ref="mesInicial"
      required
    >
      <template #label>
        <div>
          <span>Mês inicial</span>
          <b-badge v-if="form.previsto" class="ml-2"
            >Previsão: {{ retornarMes(form.etapa.mesInicial) }}</b-badge
          >
        </div>
      </template>
    </input-select>
    <input-select
      class="col-12 col-md-3"
      @input="salvarEtapa"
      :disabled="!controlesLiberados"
      :options="mesesDepesas"
      v-model="form.etapa.mesFinalRealizado"
      ref="mesFinal"
      required
    >
      <template #label>
        <div>
          <span>Mês final</span>
          <b-badge v-if="form.previsto" class="ml-2"
            >Previsão: {{ retornarMes(form.etapa.mesFinal) }}</b-badge
          >
        </div>
      </template>
    </input-select>

    <template v-for="subetapa in form.subetapas">
      <div class="col-12" :key="subetapa.id">
        <div class="row">
          <input-text
            class="col-2"
            label="Nº subetapa"
            readonly
            v-model="subetapa.numero"
          >
            <template #prepend>
              <div class="d-flex">
                <b-button
                  variant="flat-danger"
                  v-if="!subetapa.prevista && controlesLiberados"
                  class="mr-2"
                  @click="removerSubetapa(subetapa)"
                  ><i class="fas fa-trash"></i
                ></b-button>
              </div>
            </template>
          </input-text>
          <input-text
            class="col-11 col-md-4"
            @blur="salvarSubetapa(subetapa)"
            :readonly="subetapa.prevista || !controlesLiberados"
            label="Titulo da subetapa"
            v-model="subetapa.tituloDaEtapa"
          />
          <input-select
            class="col-12 col-md-3"
            :has-error-custom="erroSubetapa"
            :disabled="!controlesLiberados"
            @input="salvarSubetapa(subetapa)"
            label="Mês inicial"
            :options="mesesDepesas"
            v-model="subetapa.mesInicialRealizado"
            ref="mesInicial"
            required
          >
            <template #label>
              <div>
                <span>Mês inicial</span>
                <b-badge v-if="subetapa.prevista" class="ml-2"
                  >Previsão: {{ retornarMes(subetapa.mesInicial) }}</b-badge
                >
              </div>
            </template>
          </input-select>
          <input-select
            class="col-12 col-md-3"
            @input="salvarSubetapa(subetapa)"
            :disabled="!controlesLiberados"
            label="Mês final"
            :options="mesesDepesas"
            v-model="subetapa.mesFinalRealizado"
            ref="mesFinal"
            required
          >
            <template #label>
              <div>
                <span>Mês final</span>
                <b-badge v-if="subetapa.prevista" class="ml-2"
                  >Previsão: {{ retornarMes(subetapa.mesFinal) }}</b-badge
                >
              </div>
            </template>
          </input-select>
        </div>
      </div>
    </template>

    <div class="col-12 mb-4">
      <b-button
        variant="info"
        v-if="!form.previsto && controlesLiberados && projetoEditavel"
        size="sm"
        @click="adicionarSubetapa()"
      >
        <b-icon icon="plus-circle-fill" class="mr-2" />
        Adicionar subetapa
      </b-button>
    </div>

    <input-textarea
      class="col-12"
      @blur="controlesLiberados ? salvarDetalhamento : () => {}"
      label="Detalhamento"
      v-if="form.previsto"
      :readonly="form.previsto || !controlesLiberados"
      v-model="form.detalhamento"
    />
    <input-textarea
      class="col-12"
      @blur="controlesLiberados ? salvarDetalhamento : () => {}"
      label="Detalhamento realizado"
      :readonly="!controlesLiberados"
      v-model="form.detalhamentoRealizado"
    />

    <template v-for="relatorio in form.relatoriosEtapas">
      <div class="col-12" :key="relatorio.id">
        <div class="row">
          <input-text
            class="col-2"
            label="Nº relatório"
            readonly
            v-model="relatorio.numero"
          >
            <template #prepend>
              <div class="d-flex">
                <b-button
                  variant="flat-danger"
                  v-if="!relatorio.prevista && controlesLiberados && !relatorio.aprovado"
                  class="mr-2"
                  @click="removerRelatorio(relatorio)"
                  ><i class="fas fa-trash"></i
                ></b-button>
              </div>
            </template>
          </input-text>
          <input-text
            :class="`col-10 col-md-${relatorio.id && controlesLiberados ? 4 : 8}`"
            @blur="salvarRelatorio(relatorio)"
            :readonly="form.previsto || !controlesLiberados || relatorio.aprovado"
            label="Titulo do relatório"
            v-model="relatorio.titulo"
          />
          <input-date-time
            class="col-12 col-md-3"
            @blur="salvarRelatorio(relatorio)"
            :readonly="!controlesLiberados || relatorio.aprovado"
            label="Data de emissão"
            v-model="relatorio.dataEmissao"
          >
            <template #label>
              <div>
                <span>Data de emissão</span>
                <b-badge v-if="form.previsto" class="ml-2"
                  >Previsão: {{ retornarMes(relatorio.mesFinal) }}</b-badge
                >
              </div>
            </template>
          </input-date-time>
          <input-file
            v-if="relatorio.id && projetoEditavel"
            :readonly="!controlesLiberados || relatorio.aprovado"
            class="col-10 col-md-3"
            @input="
              (file, nomeArquivo) => {
                upload(file, nomeArquivo, relatorio);
              }
            "
            label="Arquivos"
            v-model="relatorio.arquivoBase64"
          >
            <template #append>
              <!-- <b-button
                variant="flat-primary"
                class="ml-2"
                @click="mostrarArquivos(relatorio)"
              >
                <i class="fa-solid fa-angle-down mr-2"></i>
                {{ !relatorio.mostrarArquivos ? "Mostrar" : "Esconder" }} arquivos
              </b-button> -->
              <b-button
                variant="flat-success"
                @click="aprovar(relatorio)"
                v-if="!relatorio.aprovado && liberadoAprovar && projetoEditavel"
              >
                <i class="fa-solid fa-thumbs-up mr-2"></i>
                Aprovar
              </b-button>
              <div class="align-self-center">
                <b-badge variant="success" v-if="relatorio.aprovado">Aprovado</b-badge>
              </div>
            </template>
          </input-file>
          <div class="col-12" v-if="relatorio.arquivos.length > 0">
            <b-table-simple small class="mt-2">
              <b-thead head-variant="dark">
                <b-tr>
                  <b-th class="col-6">Nome Arquivo</b-th>
                  <b-th class="col-2">Versão</b-th>
                  <b-th class="col-4">Ações</b-th>
                </b-tr>
              </b-thead>
              <tbody>
                <b-tr v-for="(arquivo, i) in relatorio.arquivos" :key="`arquivo_${i}`">
                  <b-td>{{ arquivo.nomeArquivoAWS }}</b-td>
                  <b-td>{{ arquivo.versao }}</b-td>
                  <b-td class="d-flex">
                    <b-button @click="download(arquivo.id)" variant="flat-info">
                      <i class="fas fa-cloud-download mr-2"></i>
                      Baixar arquivo
                    </b-button>
                    <b-button @click="excluir(arquivo.id)" variant="flat-danger">
                      <i class="fas fa-trash mr-2"></i>
                      Deletar arquivo
                    </b-button>
                  </b-td>
                </b-tr>
              </tbody>
            </b-table-simple>
          </div>
        </div>
      </div>
    </template>
    <div class="col-12 mb-4">
      <b-button
        variant="info"
        v-if="!form.previsto && controlesLiberados"
        size="sm"
        @click="addRelatorio()"
      >
        <b-icon icon="plus-circle-fill" class="mr-2" />
        Adicionar relatório
      </b-button>
    </div>
  </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputText from "@/components/inputs/InputText";
import InputFile from "@/components/inputs/InputFile";
import InputDateTime from "@/components/inputs/InputDateTime";

import { FormMixin } from "@/common/mixins/FormMixin";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import ProjetoService from "@/common/services/projeto/projeto.service";

import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

export default {
  name: "ModalCronograma",
  mixins: [FormMixin, AlertasMixin],
  props: {
    duracao: {
      required: true,
    },
    dataInicio: {
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    },
    numeroEtapa: {
      required: true,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InputSelect,
    InputTextarea,
    InputText,
    InputFile,
    InputDateTime,
  },
  data: () => ({
    erroEtapa: false,
    erroSubetapa: false,
  }),
  methods: {
    aprovar: function (relatorio) {
      this.confirmar("Deseja aprovar relatório?").then((confirmado) => {
        if (!confirmado) return;

        this.$store.dispatch(START_LOADING);
        ProjetoService.aprovarRelatorio(relatorio.id)
          .then(() => {
            this.toast(`Relatorio aprovado com sucesso`, {
              variant: "success",
              title: "Sucesso",
            });
            relatorio.aprovado = true;
            this.$emit("update");
          })
          .catch(() => {
            this.toast(`Erro ao aprovar relatório`, {
              variant: "danger",
              title: "Erro",
            });
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },
    // mostrarArquivos: function (relatorio) {
    //   relatorio.mostrarArquivos = !relatorio.mostrarArquivos;
    //   this.$forceUpdate();
    // },
    upload: function (file, nomeArquivo, relatorio) {
      let form = {
        entregavelId: null,
        relatorioEtapaId: relatorio.id,
        versao: relatorio.arquivos.length + 1,
        conteudoBase64: file,
        nomeArquivoAWS: nomeArquivo,
      };

      this.$store.dispatch(START_LOADING);
      ProjetoService.uploadRelatorio(form)
        .then(() => {
          this.toast(`Upload realizado com sucesso`, {
            variant: "success",
            title: "Sucesso",
          });
          relatorio.arquivos.push({
            versao: form.versao,
            conteudoBase64: file,
            nomeArquivoAWS: nomeArquivo,
          });
          this.$emit("update");
        })
        .catch(() => {
          this.toast(`Erro ao realizar upload do relatório`, {
            variant: "danger",
            title: "Erro",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    
    excluir: function (id) {
      this.confirmar("Deseja excluir este arquivo?").then((confirmado) => {
        if (!confirmado) return;
        this.$store.dispatch(START_LOADING);
        ProjetoService.excluirArquivo(id)
          .then(() => {
            const relatorioIndex = this.form.relatoriosEtapas.findIndex(
              (relatorio) => relatorio.arquivos.some((arq) => arq.id === id)
            );
            if (relatorioIndex !== -1) {
              const arquivoIndex = this.form.relatoriosEtapas[relatorioIndex].arquivos.findIndex(
                (arq) => arq.id === id
              );
              if (arquivoIndex !== -1) {
                this.form.relatoriosEtapas[relatorioIndex].arquivos.splice(arquivoIndex, 1);
              }
            }
            this.toast("Arquivo excluído com sucesso", { variant: "success" });
            this.$emit("update");
          })
          .catch(() => {
            this.toast("Erro ao excluir arquivo", { variant: "danger" });
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    download: function (id) {
      this.$store.dispatch(START_LOADING);

      ProjetoService.downloadRelatorio(id)
      .then(response => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");               
      })
      .catch(err => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
      })
      .finally(() => {
          this.$store.dispatch(STOP_LOADING);
      });
    },

    salvarDetalhamento: function () {
      if (!this.form.id) return;

      ProjetoService.salvarDetalhamento(this.form)
        .then(() => {
          this.toast("Detalhamento atualizado com sucesso", { variant: "success" });
          this.$emit("update");
        })
        .catch(() => {
          this.toast("Erro ao atualizar detalhamento", { variant: "danger" });
        });
    },

    salvarEtapa: function () {
      if (!this.projetoEditavel) return;

      if (!this.form.id) return;

      if (
        this.form.etapa.mesInicialRealizado == "" ||
        this.form.etapa.mesFinalRealizado == ""
      ) {
        return;
      }

      if (this.form.etapa.tituloDaEtapa == "") {
        this.alertaAviso("Preencha o título da etapa");
        this.$refs.tituloEtapa.valid();
        return;
      }

      if (this.form.etapa.mesInicialRealizado > this.form.etapa.mesFinalRealizado) {
        this.alertaAviso("O mês inicial não pode ser maior que o mês final");
        this.erroEtapa = "O mês inicial não pode ser maior que o mês final";
        return;
      }

      this.erroEtapa = false;

      ProjetoService.salvarEtapa(this.form)
        .then(() => {
          this.toast("Etapa salva com sucesso", { variant: "success" });
          this.$emit("update");
        })
        .catch(() => {
          this.toast("Erro ao salvar etapa", { variant: "danger" });
        });
    },

    salvarSubetapa: function (subetapa) {
      if (!this.form.id) return;

      if (!subetapa.mesInicialRealizado || !subetapa.mesFinalRealizado) {
        return;
      }

      if (subetapa.tituloDaEtapa == "") {
        this.alertaAviso("Preencha o título da etapa");
        return;
      }

      if (subetapa.mesInicialRealizado > subetapa.mesFinalRealizado) {
        this.alertaAviso("O mês inicial não pode ser maior que o mês final");
        this.erroSubetapa = "O mês inicial não pode ser maior que o mês final";
        return;
      }

      this.erroSubetapa = false;

      ProjetoService.salvarSubetapa(subetapa)
        .then((res) => {
          if (res) {
            delete subetapa.cronogramaEtapaId;
            subetapa.id = res;
          }

          this.toast("Subetapa salva com sucesso", { variant: "success" });
          this.$emit("update");
        })
        .catch(() => {
          this.toast("Erro ao salvar subetapa", { variant: "danger" });
        });
    },

    salvarRelatorio: function (relatorio) {
      if (!this.form.id) return;

      if (!relatorio.dataEmissao) {
        return;
      }

      if (relatorio.titulo == "") {
        this.alertaAviso("Preencha o título do relatório");
        return;
      }

      ProjetoService.salvarRelatorio(relatorio)
        .then((res) => {
          if (res) {
            delete relatorio.cronogramaEtapaId;
            relatorio.id = res;
            this.$forceUpdate();
          }
          this.toast("Relatório salvo com sucesso", { variant: "success" });
          this.$emit("update");
        })
        .catch(() => {
          this.toast("Erro ao salvar relatório", { variant: "danger" });
        });
    },

    adicionarSubetapa: function () {
      let numero =
        this.form.subetapas.length == 0
          ? 1
          : parseInt(
              this.form.subetapas[this.form.subetapas.length - 1].numero.substring(
                this.form.subetapas[this.form.subetapas.length - 1].numero.indexOf(".") +
                  1
              )
            ) + 1;

      this.form.subetapas.push({
        cronogramaEtapaId: this.form.id,
        numero: `${this.numeroEtapa}.${numero}`,
        tituloDaEtapa: null,
        mesInicial: null,
        mesFinal: null,
        mesInicialRealizado: null,
        mesFinalRealizado: null,
        prevista: false,
      });
    },

    removerSubetapa: function (subetapa) {
      if (subetapa.id) {
        this.confirmar("Alerta", "Deseja realmente remover esta subetapa?").then((v) => {
          if (v) {
            ProjetoService.removerSubetapa(subetapa.id)
              .then(() => {
                this.form.subetapas.splice(this.form.subetapas.indexOf(subetapa), 1);
                this.toast("Subetapa removido com sucesso", { variant: "success" });
                this.$emit("update");
              })
              .catch(() => {
                this.toast("Erro ao remover subetapa", { variant: "danger" });
              });
          }
        });
      } else this.form.subetapas.splice(this.form.subetapas.indexOf(subetapa), 1);
    },

    addRelatorio: function () {
      let numero =
        this.form.relatoriosEtapas.length == 0
          ? this.etapaNumero
          : `${this.etapaNumero}.${helpers
              .getLetra(
                typeof this.form.relatoriosEtapas[this.form.relatoriosEtapas.length - 1]
                  .numero == "number"
                  ? 1
                  : helpers.getAlfabeto().find((el) => {
                      let indice = this.form.relatoriosEtapas[
                        this.form.relatoriosEtapas.length - 1
                      ].numero
                        .substring(
                          this.form.relatoriosEtapas[
                            this.form.relatoriosEtapas.length - 1
                          ].numero.indexOf(".") + 1
                        )
                        .toUpperCase();
                      return el.text == (indice > 0 ? "A" : indice);
                    }).value + 1
              )
              .text.toLowerCase()}`;

      this.form.relatoriosEtapas.push({
        cronogramaEtapaId: this.form.id,
        numero: numero,
        titulo: "RELATÓRIO DE ETAPA",
        mesFinal: null,
        mesFinalRealizado: null,
        dataEmissao: null,
        arquivos: [],
        arquivoBase64: null,
        previsto: false,
      });
    },

    removerRelatorio: function (relatorio) {
      if (relatorio.id) {
        this.confirmar("Alerta", "Deseja realmente remover este relatório?").then((v) => {
          if (v) {
            ProjetoService.removerRelatorio(relatorio.id)
              .then(() => {
                this.form.relatoriosEtapas.splice(
                  this.form.relatoriosEtapas.indexOf(relatorio),
                  1
                );
                this.toast("Relatório removido com sucesso", { variant: "success" });
                this.$emit("update");
              })
              .catch(() => {
                this.toast("Erro ao remover relatório", { variant: "danger" });
              });
          }
        });
      } else
        this.form.relatoriosEtapas.splice(
          this.form.relatoriosEtapas.indexOf(relatorio),
          1
        );
    },

    retornarMes: function (mes) {
      return this.mesesDepesas.find((el) => el.value == mes).text;
    },
  },
  computed: {
    mesesDepesas: function () {
      let meses = [];

      let ano = helpers.formatarData(this.dataInicio, "YYYY");
      let mes = helpers.formatarData(this.dataInicio, "MM");

      for (let index = 0; index <= this.duracao; index++) {
        meses.push({
          value: index + 1,
          text: `${helpers.retornarNomeMes(mes)}/${ano}`,
        });

        mes++;
        if (mes > 12) {
          mes = 1;
          ano++;
        }
      }
      return meses;
    },
    etapaNumero: {
      get: function () {
        return this.form.etapa.numero ? this.form.etapa.numero : this.numeroEtapa;
      },
    },
    controlesLiberados: function () {
      return (
        this.$route.name == "projeto-detalhamento-executora-criadora" &&
        this.projetoEditavel
      );
    },
    liberadoAprovar: function () {
      return (
        this.$route.name == "projeto-detalhamento" ||
        this.$route.name == "projeto-detalhamento-proponente-cooperada"
      );
    },
  },
  watch: {
    numeroEtapa: {
      handler: function () {
        if (!this.form.id) this.form.etapa.numero = this.numeroEtapa;
      },
      immediate: true,
    },
  },
};
</script>
<style lang=""></style>
